import { render, staticRenderFns } from "./StatisticsCentreAbnormal.vue?vue&type=template&id=7cd47994&scoped=true"
import script from "./StatisticsCentreAbnormal.vue?vue&type=script&lang=js"
export * from "./StatisticsCentreAbnormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd47994",
  null
  
)

export default component.exports